<template>
    <div class="row dashboard-info-widgets">
        <div class="col-md-6 col-xl-3">
            <vuestic-widget class="info-widget">
                <div class="info-widget-inner">
                    <div class="stats">
                        <div class="stats-number">
                            <i class="fa fa-check icon-size text-success"></i>
                            <div class="ml-2">{{ aulasAceitas }}</div>
                        </div>
                        <div class="stats-title">Práticas Aceitas</div>
                    </div>
                </div>
            </vuestic-widget>
        </div>
        <div class="col-md-6 col-xl-3">
            <vuestic-widget class="info-widget">
                <div class="info-widget-inner">
                    <div class="stats">
                        <div class="stats-number">
                            <i class="fa fa-hourglass-half icon-size"></i>
                            <div class="ml-2">{{ aulasPendentes }}</div>
                        </div>
                        <div class="stats-title">Práticas Em Análise</div>
                    </div>
                </div>
            </vuestic-widget>
        </div>
        <div class="col-md-6 col-xl-3">
            <vuestic-widget class="info-widget">
                <div class="info-widget-inner">
                    <div class="stats">
                        <div class="stats-number">
                            <i class="fa fa-exclamation stats-icon text-danger"></i>
                            {{ aulasRejeitadas }}
                        </div>
                        <div class="stats-title">Práticas Recusadas</div>
                    </div>
                </div>
            </vuestic-widget>
        </div>
        <div class="col-md-6 col-xl-3">
            <vuestic-widget class="info-widget">
                <div class="info-widget-inner">
                    <div class="stats">
                        <div class="stats-number">
                            <i class="fa fa-ban stats-icon text-danger"></i>
                            <div class="ml-2">{{ aulasCanceladas }}</div>
                        </div>
                        <div class="stats-title">Práticas Canceladas</div>
                    </div>
                </div>
            </vuestic-widget>
        </div>
    </div>
</template>

<script>
import urlApiV2 from "@/router/urlApiV2";

export default {
    name: "dashboard-aulas-info",
    data() {
        return {
            aulasAceitas:    0,
            aulasPendentes:  0,
            aulasRejeitadas: 0,
            aulasCanceladas: 0,
        };
    },

    methods: {
        loadClasses() {
            this.$http.get(`${urlApiV2}/aulas/praticas/relatorio/status`)
                .then((res) => {
                    this.aulasAceitas    = res.data.dados.aceitas;
                    this.aulasPendentes  = res.data.dados.em_analise;
                    this.aulasRejeitadas = res.data.dados.rejeitadas;
                    this.aulasCanceladas = res.data.dados.canceladas;
                })
                .catch((error) => {
                    this.launchToast('fa-exclamation', error.data.dados);
                });
        },

        launchToast(icon, msg) {
            Vue.toasted.show(msg, {
                icon: icon,
                position: 'top-right',
                duration: 5000,
                fullWidth: false
            })
        }
    },

    mounted() {
        this.loadClasses();
    },
};
</script>

<style lang="scss" scoped>
.stats-number,
.stats-title {
    line-height: 1;
}

.info-widget-inner {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;

    &.has-chart {
        justify-content: space-between;
    }

    .stats {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
}

.stats-number {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 2.625rem;
    margin-bottom: 0.5rem;

    .stats-icon {
        font-size: 1.5625rem;
        position: absolute;
        top: 0.625rem;
        left: -1.25rem;

        &.icon-wide {
            left: -1.875rem;
        }
    }
}

.green-arrow {
    color: rgb(30, 230, 30);
}

.icon-size {
    font-size: 0.4em;
}
</style>
